<template>
    <base-notification-card
        v-bind="$attrs"
        @card-clicked="$emit('cardClicked', $attrs.id)">
        <template #content>
            <!-- eslint-disable vue/no-v-html -->
            <div
                class="body"
                v-html="sanitizedBody" />
            <!-- eslint-enable vue/no-v-html -->
        </template>
    </base-notification-card>
</template>

<script>
import BaseNotificationCard from './base-notification-card.vue';

export default {
    name: 'CommentNotificationCard',
    components: {
        BaseNotificationCard,
    },
    inheritAttrs: false,
    emits: ['cardClicked'],
    computed: {
        sanitizedBody () {
            return this.$sanitize(this.$attrs.body);
        },
    },
};
</script>

<style scoped lang="less">
.notification-card {
    .body {
        grid-column-start: 2;
        grid-column-end: 3;
        color: var(--palette-gray-70);
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
}
</style>
